namespace GeniuzPOS.InitialData {
    export namespace PsCustomerSurveyDtService {
        export const baseUrl = 'InitialData/PsCustomerSurveyDt';

        export declare function Create(request: Serenity.SaveRequest<PsCustomerSurveyDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsCustomerSurveyDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsCustomerSurveyDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsCustomerSurveyDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsCustomerSurveyDt/Create",
            Update = "InitialData/PsCustomerSurveyDt/Update",
            Delete = "InitialData/PsCustomerSurveyDt/Delete",
            Retrieve = "InitialData/PsCustomerSurveyDt/Retrieve",
            List = "InitialData/PsCustomerSurveyDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsCustomerSurveyDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
